<template>
	<v-container grid-list-md>
		<v-simple-table>
			<template v-slot:default>
				<thead>
					<tr>
						<th class="text-left">
							{{ $t("title.tenant") }}
						</th>
						<th class="text-left">
							{{ $t("title.total_order") }}
						</th>
						<th class="text-left">
							{{ $t("title.total_reservation") }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in tenants" :key="item.name">
						<td>{{ item.name }}</td>
						<td>{{ item.orders_count }}</td>
						<td>{{ item.reservations_count }}</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>
	</v-container>
</template>

<script>
	export default {
		props: ["tenants"],
	};
</script>